import axios from "axios";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URI, // 'https://us-central1-quickdesk-4cfad.cloudfunctions.net/app/api',
  // baseURL: "http://localhost:5001/quickdesk-4cfad/us-central1/app/api",
});

const fb_api = axios.create({
  baseURL: "https://graph.facebook.com",
});

console.log(process.env.REACT_APP_API_URI);

// COMMON
export const getService = (url) => api.get(url);
export const putService = (url, payload) => api.put(url, payload);
export const postService = (url, payload) => api.post(url, payload);
export const deleteService = (url,payload) => api.delete(url,payload);
// COMMON
// Facebook
export const insertFacebookPages = (payload) =>
  api.post(`/facebook/insertPages`, payload);

// Customer
export const insertCustomer = (payload) => api.post(`/customer`, payload);
export const getAllCustomers = () => api.get(`/customers`);
export const updateCustomerById = (id, payload) =>
  api.put(`/customer/${id}`, payload);
export const updateCustomerByUid = (uid, payload) =>
  api.put(`/customer/uid/${uid}`, payload);
export const deleteCustomerById = (id) => api.delete(`/customer/${id}`);
export const getCustomerById = (id) => api.get(`/customer/${id}`);
export const getCustomerByEmail = (email) =>
  api.get(`/customer_login/${email}`);

// Business
export const insertBusiness = (payload) => api.post(`/business/`, payload);
export const getAllBusiness = () => api.get(`/business/`);
export const updateBusinessByID = (id, payload) =>
  api.put(`/business/${id}`, payload);
export const updateBusiness = (payload) => api.put(`/business`, payload);
export const deleteBusinessById = (id) => api.delete(`/business/${id}`);
export const getBusinessById = (id) => api.get(`/business/${id}`);
export const getBusinessByUid = (uid) => api.get(`/business/uid/${uid}`);

// Business Rules

export const insertBusinessRules = (payload) =>
  api.post(`/business_rules`, payload);
export const getAllBusinessRules = () => api.get(`/business_rules`);
export const updateBusinessRulesById = (biz_id, payload) =>
  api.put(`/business_rules/${biz_id}`, payload);
export const deleteBusinessRulesById = (biz_id) =>
  api.delete(`/business_rules/${biz_id}`);
export const getBusinessRulesById = (biz_id) =>
  api.get(`/business_rules/${biz_id}`);

// Chat
export const getChatHistoryById = (id) => api.get(`/chat/${id}`);

// Facebook Graph
export const getFBService = (url) => fb_api.get(url);

export const getFbPageImage = (page_id) =>
  fb_api.get(`/${page_id}/picture?type=large&redirect=0`);

export const getAllQueries = () => api.get(`/business/`);

// Default Metrics
export const getAllDefaultMetrics = () => api.get(`/default_metrics`);
export const getDefaultMetricsById = (id) => api.get(`/default_metrics/${id}`);

const apis = {
  insertCustomer,
  getAllCustomers,
  updateCustomerById,
  updateCustomerByUid,
  deleteCustomerById,
  getCustomerById,
  getCustomerByEmail,

  insertBusinessRules,
  getAllBusinessRules,
  updateBusinessRulesById,
  deleteBusinessRulesById,
  getBusinessRulesById,

  insertBusiness,
  getAllBusiness,
  updateBusinessByID,
  deleteBusinessById,
  getBusinessById,
  getBusinessByUid,
  updateBusiness,

  getChatHistoryById,
  getFbPageImage,
  getFBService,

  getAllQueries,
  getAllDefaultMetrics,
  getDefaultMetricsById,

  insertFacebookPages,
  getService,
  putService,
  postService,
  deleteService,
};

export default apis;
